import { JSX, options as preactOptions, VNode } from "preact";
import { Configuration, setup as twSetup, Sheet, tw } from "twind";

type PreactOptions = typeof preactOptions & { __b?: (vnode: VNode) => void };

export const STYLE_ELEMENT_ID = "__FRSH_TWIND";

export interface Options extends Omit<Configuration, "mode" | "sheet"> {
  /** The import.meta.url of the module defining these options. */
  selfURL: string;
}

declare module "preact" {
  namespace JSX {
    interface DOMAttributes<Target extends EventTarget> {
      class?: string;
      className?: string;
    }
  }
}

export function setup(options: Options, sheet: Sheet) {
  const config: Configuration = {
    ...options,
    mode: "silent",
    sheet,
  };
  twSetup(config);

  // Hook into options._diff which is called whenever a new comparison
  // starts in Preact.
  const originalHook = (preactOptions as PreactOptions).__b;
  (preactOptions as PreactOptions).__b = (
    // deno-lint-ignore no-explicit-any
    vnode: VNode<JSX.DOMAttributes<any>>,
  ) => {
    if (typeof vnode.type === "string" && typeof vnode.props === "object") {
      const { props } = vnode;
      const classes: string[] = [];
      if (props.class) {
        classes.push(tw(props.class));
        props.class = undefined;
      }
      if (props.className) {
        classes.push(tw(props.className));
        props.className = undefined;
      }
      if (classes.length) {
        props.class = classes.join(" ");
      }
    }

    originalHook?.(vnode);
  };
}

// denoCacheMetadata={"headers":{"access-control-allow-origin":"*","x-content-type-options":"nosniff","date":"Wed, 25 Dec 2024 17:08:11 GMT","accept-ranges":"bytes","age":"23072288","cross-origin-resource-policy":"same-origin","content-length":"1520","server":"deno/gcp-us-east4","cache-control":"public, max-age=31536000, immutable","content-security-policy":"default-src 'none'; style-src 'unsafe-inline'; sandbox","server-timing":"fetchSource;dur=18","x-amz-replication-status":"COMPLETED","strict-transport-security":"max-age=63072000; includeSubDomains; preload","x-amz-cf-id":"5Nnl0PdC-DbUxRsUr__oOtIScq10t164gnB9ufhSXk-DDN6B2e2m2A==","cross-origin-embedder-policy":"same-origin","referrer-policy":"strict-origin-when-cross-origin","x-amz-version-id":"Nh5hyOxn6Y79e3l6NfA7oDj4WEkm2MF6","last-modified":"Thu, 17 Aug 2023 16:08:00 GMT","x-frame-options":"DENY","via":"http/2 edgeproxy-h","cross-origin-opener-policy":"same-origin","x-cache":"Hit from cloudfront","x-amz-server-side-encryption":"AES256","vary":"Accept-Encoding, Origin","content-type":"application/typescript; charset=utf-8","x-amz-cf-pop":"IAD61-P1","etag":"\"856f9a7d74a23a20138b7a72afbd896a\""},"url":"https://deno.land/x/fresh@1.4.2/plugins/twind/shared.ts","time":1758218778}